import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import LayoutV1 from "markup/Layout/LayoutV1";
import { connect, shallowEqual, useSelector } from "react-redux";
import * as advertEndpoint from "modules/Advert/_redux/advertEndpoint";
import * as advertRedux from "modules/Advert/_redux/advertRedux";
import * as authRedux from "modules/Auth/_redux/authRedux";
import * as initialRedux from "modules/Initial/_redux/initialRedux";
import Skeleton from "@material-ui/lab/Skeleton";
import { toast } from "react-toastify";
import { getAdvertDate, generateCategoryDetail, resolveOwnerName } from "helpers";
import AdvertBuyDialog from "modules/Main/parts/AdvertBuyDialog";
import { Helmet } from "react-helmet";
import { convertPrice } from "../../../helpers/PriceHelper";
import { floorLabel } from "helpers/floorOrder";
import AdvertCard from "modules/Main/parts/AdvertCard";
import { FaBarcode } from "react-icons/fa";
import AdvertGallery from "./parts/AdvertGallery";
import FavoriteButton from "modules/Favorite/parts/FavoriteButton";

let credit = require("images/credit1.png");
let bnr = require("images/banner/bnr3.jpg");

function AdvertDetail(props) {
  const { advertSlug } = useParams();

  const [loading, setLoading] = useState(false);
  const [dialog, setDialog] = useState(false);

  const { advertDetail, isLogged } = useSelector(
    (state) => ({
      advertDetail: state.advert.advertDetail,
      isLogged: state.auth.isLogged,
    }),
    shallowEqual
  );

  function scrollToContactContainer() {
    const element = document.getElementById("contact-buyer-container");
    const elementPosition =
      element.getBoundingClientRect().top + window.pageYOffset;
    const offset = 100; // Adjust this value to stop earlier (e.g., 100px before the element)

    window.scrollTo({
      top: elementPosition - offset,
      behavior: "smooth",
    });
  }

  useEffect(() => {
    window.scrollTo(0, 0);

    props.openPace();
    advertEndpoint
      .getAdvertDetail(advertSlug)
      .then((res) => res.data)
      .then((result) => {
        if (Number(advertSlug) >= 180000)
          return props.history.push(`/ilan/${result.slug}`);

        props.setAdvert(result);
        props.closePace();

        advertEndpoint
          .getSimilarAdverts(advertSlug, {
            _id: result._id,
            category: { _id: result.category._id },
            filters: result.filters,
          })
          .then(({ data }) => data)
          .then((similarAdverts) =>
            props.setAdvert({ ...result, similarAdverts })
          );

        if (result.user?.name) scrollToContactContainer();
      });

    return () => {
      props.cleanAdvert();
    };
  }, [advertSlug]);

  function takeAdvert(advertId) {
    setLoading(true);
    setDialog(false);
    props.openPace();
    advertEndpoint
      .takeAdvert(advertId)
      .then((res) => res.data)
      .then((result) => {
        toast(result.message);
        props.setBalance(result.balance);
        props.setHiddenData(result.hiddenData);
        setLoading(false);
        props.closePace();
      })
      .catch((err) => {
        setLoading(false);
        props.closePace();
      });
  }

  const isSeller = advertDetail.kind === "seller";
  const sellerName = resolveOwnerName(advertDetail.user, advertDetail.advertNo);
  const sellerPhone =
    advertDetail.privacy && advertDetail.privacy[0]
      ? advertDetail.privacy[0].phone
      : "";
  const showSellerPhone = advertDetail.showPhoneNumber && !!sellerPhone;
  const isRent = advertDetail.listingType === "rent";
  const rentSuffix = isRent ? " /ay" : "";
  const filterDefs = advertDetail.category?.filters || [];
  const filterValues =
    (Array.isArray(advertDetail.filters) && advertDetail.filters[0]) || {};

  const specRows = [];
  const pushSpec = (label, value) => {
    if (value === undefined || value === null || value === "") return;
    specRows.push([label, value]);
  };

  pushSpec("İlan Tipi", isRent ? "Kiralık" : "Satılık");

  if (advertDetail.vehicleBrand?.name)
    pushSpec("Marka", advertDetail.vehicleBrand.name);
  if (advertDetail.vehicleModel?.name)
    pushSpec("Model", advertDetail.vehicleModel.name);

  if (isSeller) {
    pushSpec("Yıl", advertDetail.year);
    if (advertDetail.km != null && advertDetail.km !== "")
      pushSpec("Kilometre", `${convertPrice(advertDetail.km)} km`);
    pushSpec("Metrekare", advertDetail.m2 != null ? `${advertDetail.m2} m²` : "");
    pushSpec("Bulunduğu Kat", advertDetail.bulunduguKat);
    if (advertDetail.katSayisi != null && advertDetail.katSayisi !== "")
      pushSpec("Kat Sayısı", advertDetail.katSayisi);
  } else {
    if (advertDetail.yearMin || advertDetail.yearMax)
      pushSpec(
        "Yıl Aralığı",
        `${advertDetail.yearMin ?? ""}${
          advertDetail.yearMin && advertDetail.yearMax ? " - " : ""
        }${advertDetail.yearMax ?? ""}`
      );
    if (advertDetail.kmMax != null && advertDetail.kmMax !== "")
      pushSpec("En Fazla Kilometre", `${convertPrice(advertDetail.kmMax)} km`);
    if (advertDetail.m2Min || advertDetail.m2Max)
      pushSpec(
        "Metrekare Aralığı",
        `${advertDetail.m2Min ?? ""}${
          advertDetail.m2Min && advertDetail.m2Max ? " - " : ""
        }${advertDetail.m2Max ?? ""} m²`
      );
    if (advertDetail.bulunduguKatMinIdx != null || advertDetail.bulunduguKatMaxIdx != null) {
      const lo = floorLabel(advertDetail.bulunduguKatMinIdx);
      const hi = floorLabel(advertDetail.bulunduguKatMaxIdx);
      if (lo && hi) pushSpec("Bulunduğu Kat Aralığı", `${lo} - ${hi}`);
      else if (lo) pushSpec("Bulunduğu Kat Aralığı", `${lo} ve üzeri`);
      else if (hi) pushSpec("Bulunduğu Kat Aralığı", `${hi} ve altı`);
    }
    if (advertDetail.katSayisiMin || advertDetail.katSayisiMax)
      pushSpec(
        "Kat Sayısı Aralığı",
        `${advertDetail.katSayisiMin ?? ""}${
          advertDetail.katSayisiMin && advertDetail.katSayisiMax ? " - " : ""
        }${advertDetail.katSayisiMax ?? ""}`
      );
  }

  filterDefs.forEach((def) => {
    const value = filterValues[def.slug];
    if (value === undefined || value === null || value === "") return;
    pushSpec(
      def.title || def.slug,
      Array.isArray(value) ? value.join(", ") : value
    );
  });

  const hasLocation =
    advertDetail.location?.province?.name ||
    advertDetail.location?.district?.name;

  // Harita yalnızca satıcı emlak ilanında anlamlı (alıcı want-ad'inde belirli
  // bir mülk yok). Koordinat saklamadığımız için il/ilçe adıyla keyless Google
  // embed kullanıyoruz — yaklaşık bölgeyi gösterir, tam adresi değil.
  const showLocationMap =
    isSeller && advertDetail.category?.slug === "emlak" && hasLocation;
  const mapQuery = encodeURIComponent(
    [
      advertDetail.location?.neighborhood,
      advertDetail.location?.district?.name,
      advertDetail.location?.province?.name,
      "Türkiye",
    ]
      .filter(Boolean)
      .join(", ")
  );
  // Mahalle bilindiğinde haritayı daha yakın yakınlaştır.
  const mapZoom = advertDetail.location?.neighborhood ? 14 : 12;
  const mapEmbedUrl = `https://maps.google.com/maps?q=${mapQuery}&z=${mapZoom}&output=embed`;

  if (!props.advert.advertDetail.title) {
    return (
      <LayoutV1>
        <div className="page-content bg-white">
          <Skeleton animation="wave" variant="rect" height={120} />
          <div>
            <div className="container mt-5">
              <div className="row">
                <div className="col-lg-4">
                  <Skeleton animation="wave" variant="rect" height={500} />
                </div>
                <div className="col-lg-8">
                  <Skeleton animation="wave" variant="rect" height={500} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutV1>
    );
  }

  return (
    <LayoutV1>
      <Helmet>
        <title>Alıcılar - {advertDetail.title}</title>
        <meta name="description" content={advertDetail.body} />
      </Helmet>
      <div className="page-content bg-white">
        <div
          className="dez-bnr-inr "
          style={{
            backgroundColor: "#fbfbfb",
            boxShadow: "rgb(0 0 0 / 6%) 0px 0px 10px 0px",
          }}
        >
          <div className="container">
            <div className="dez-bnr-inr-entry">
              <h1 className="text-black text-left">
                {props.advert.advertDetail.title}
              </h1>
              <div className="breadcrumb-row">
                <ul className="list-inline d-flex justify-content-start">
                  <li>
                    <Link to={"/"} style={{ color: "#000" }}>
                      Anasayfa
                    </Link>
                  </li>
                  <li>
                    {advertDetail?.category?.slug ? (
                      <Link
                        to={generateCategoryDetail(advertDetail.category.slug)}
                        style={{ color: "#000" }}
                      >
                        {advertDetail.category.name}
                      </Link>
                    ) : (
                      <span style={{ color: "#000" }}>
                        {advertDetail?.category?.name}
                      </span>
                    )}
                  </li>
                  {/*   <li style={{ color: "#000" }}>
                    {" "}
                    {props.advert.advertDetail.title}
                  </li>*/}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="content-block">
          <div className="section-full content-inner-1">
            <div className="container">
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="sticky-top">
                    <div className="row">
                      <div className="col-lg-12">
                        <AdvertGallery
                          photos={
                            advertDetail.photos && advertDetail.photos.length
                              ? advertDetail.photos
                              : advertDetail.images
                              ? [advertDetail.images]
                              : []
                          }
                          alt={advertDetail.title}
                        />

                        <FavoriteButton
                          advertId={advertDetail.id}
                          variant="labeled"
                        />

                        {!isSeller && (
                          <button
                            onClick={() => {
                              if (isLogged) {
                                setDialog(true);
                              } else {
                                localStorage.setItem(
                                  "pageToRedirectAfterLogin",
                                  window.location.pathname
                                );
                                window.location.href = "/login";
                              }
                            }}
                            className="my-3 font-weight-bold contact-buyer-button contact-button--buyer"
                            disabled={loading}
                          >
                            {loading
                              ? "Lütfen bekleyiniz..."
                              : "Alıcı ile İletişime Geç"}
                          </button>
                        )}

                        <div className="widget bg-white p-lr20 p-t20  widget_getintuch radius-sm">
                          <h4 className="text-black font-weight-700 p-t10 m-b15">
                            İlan Detayı
                          </h4>
                          <ul>
                            <li>
                              <i className="ti-location-pin" />
                              <strong className="font-weight-700 text-black">
                                Konum
                              </strong>
                              <span>
                                {advertDetail.location?.province?.name}
                                {` ${
                                  advertDetail.location?.district?.name
                                    ? "/"
                                    : ""
                                }`}
                                {advertDetail.location?.district?.name}
                                {advertDetail.location?.neighborhood
                                  ? ` / ${advertDetail.location.neighborhood}`
                                  : ""}
                              </span>
                            </li>

                            {advertDetail.vehicleBrand?.name ? (
                              <li>
                                <i className="ti-car" />
                                <strong className="font-weight-700 text-black">
                                  Marka
                                </strong>{" "}
                                {advertDetail.vehicleBrand.name}
                              </li>
                            ) : null}

                            {advertDetail.vehicleModel?.name ? (
                              <li>
                                <i className="ti-bookmark" />
                                <strong className="font-weight-700 text-black">
                                  Model
                                </strong>{" "}
                                {advertDetail.vehicleModel.name}
                              </li>
                            ) : null}

                            {advertDetail.kind === "seller" &&
                            advertDetail.year != null &&
                            advertDetail.year !== "" ? (
                              <li>
                                <i className="ti-calendar" />
                                <strong className="font-weight-700 text-black">
                                  Yıl
                                </strong>{" "}
                                {advertDetail.year}
                              </li>
                            ) : null}

                            {advertDetail.kind !== "seller" &&
                            (advertDetail.yearMin || advertDetail.yearMax) ? (
                              <li>
                                <i className="ti-calendar" />
                                <strong className="font-weight-700 text-black">
                                  Yıl Aralığı
                                </strong>{" "}
                                {advertDetail.yearMin ?? ""}
                                {advertDetail.yearMin && advertDetail.yearMax
                                  ? " - "
                                  : ""}
                                {advertDetail.yearMax ?? ""}
                              </li>
                            ) : null}

                            {advertDetail.kind === "seller" &&
                            advertDetail.km != null &&
                            advertDetail.km !== "" ? (
                              <li>
                                <i className="ti-dashboard" />
                                <strong className="font-weight-700 text-black">
                                  Kilometre
                                </strong>{" "}
                                {convertPrice(advertDetail.km)} km
                              </li>
                            ) : null}

                            {advertDetail.kind !== "seller" &&
                            advertDetail.kmMax != null &&
                            advertDetail.kmMax !== "" ? (
                              <li>
                                <i className="ti-dashboard" />
                                <strong className="font-weight-700 text-black">
                                  En Fazla Kilometre
                                </strong>{" "}
                                {convertPrice(advertDetail.kmMax)} km
                              </li>
                            ) : null}

                            {advertDetail.kind === "seller" ? (
                              <>
                                <li>
                                  <i className="ti-tag" />
                                  <strong className="font-weight-700 text-black">
                                    {isRent ? "Aylık Kira" : "Fiyat"}
                                  </strong>{" "}
                                  {convertPrice(advertDetail.price)} ₺
                                  {rentSuffix}
                                </li>
                                {advertDetail.condition ? (
                                  <li>
                                    <i className="ti-info-alt" />
                                    <strong className="font-weight-700 text-black">
                                      Durum
                                    </strong>{" "}
                                    {{
                                      new: "Sıfır",
                                      used: "İkinci El",
                                      refurbished: "Yenilenmiş",
                                    }[advertDetail.condition] ||
                                      advertDetail.condition}
                                  </li>
                                ) : null}
                                {advertDetail.tradeable ? (
                                  <li>
                                    <i className="ti-exchange-vertical" />
                                    <strong className="font-weight-700 text-black">
                                      Takas
                                    </strong>{" "}
                                    Açık
                                  </li>
                                ) : null}
                              </>
                            ) : (
                              <>
                                <li>
                                  <i className="ti-arrow-up" />
                                  <strong className="font-weight-700 text-black">
                                    {isRent ? "Maksimum Kira" : "Maximum Fiyat"}
                                  </strong>{" "}
                                  {convertPrice(advertDetail.priceMax)} ₺
                                  {rentSuffix}
                                </li>

                                <li>
                                  <i className="ti-arrow-down" />
                                  <strong className="font-weight-700 text-black">
                                    {isRent ? "Minimum Kira" : "Minimum Fiyat"}
                                  </strong>{" "}
                                  {convertPrice(advertDetail.priceMin)} ₺
                                  {rentSuffix}
                                </li>
                              </>
                            )}

                            <li>
                              <i className="ti-time" />
                              <strong className="font-weight-700 text-black">
                                Yayınlanma Tarihi
                              </strong>
                              {getAdvertDate(
                                props.advert.advertDetail.createdAt
                              )}
                            </li>

                            {!isSeller && (
                              <li>
                                <i className="">
                                  <img src={credit} width="20" alt="" />
                                </i>
                                <strong className="font-weight-700 text-black">
                                  Gerekli Bakiye
                                </strong>{" "}
                                {props.advert.advertDetail.acoin}
                              </li>
                            )}

                            <li>
                              <i className="">
                                <FaBarcode />
                              </i>
                              <strong className="font-weight-700 text-black">
                                İlan No
                              </strong>{" "}
                              {props.advert.advertDetail.advertNo}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-8 col-md-6">
                  <div className="job-info-box">
                    {isSeller ? (
                      <div
                        className="advert-owner-card mb-4"
                        style={{
                          background:
                            "linear-gradient(135deg, #e9fbef 0%, #d6f7e0 100%)",
                          border: "2px solid #1EC28B",
                          borderRadius: 12,
                          padding: 20,
                          boxShadow: "0 6px 18px rgba(30,194,139,0.18)",
                        }}
                      >
                        <h3 className="m-t0 m-b15 font-weight-700 text-black">
                          İlan Sahibi
                        </h3>
                        <div className="mb-2" style={{ fontSize: 16 }}>
                          <b>İsim</b> :{" "}
                          {sellerName}
                        </div>
                        {showSellerPhone ? (
                          <a
                            href={`tel:${sellerPhone}`}
                            className="d-inline-flex align-items-center font-weight-700"
                            style={{
                              background: "#1EC28B",
                              color: "#fff",
                              borderRadius: 8,
                              padding: "10px 18px",
                              fontSize: 18,
                              textDecoration: "none",
                              marginTop: 6,
                              marginBottom: 6,
                            }}
                          >
                            <i className="fa fa-phone mr-2" />
                            {sellerPhone}
                          </a>
                        ) : null}
                        {props.advert.advertDetail.allowMessages ? (
                          <div className="mt-3">
                            <Link
                              to={`/messages/${props.advert.advertDetail.user.id}?advert=${props.advert.advertDetail.slug}`}
                              className="bg-primary p-2 rounded text-white send-message-button outline-none border-0 cursor-pointer"
                            >
                              Mesaj Gönder
                            </Link>
                          </div>
                        ) : null}
                      </div>
                    ) : null}

                    {specRows.length > 0 ? (
                      <div className="advert-spec-block mb-4">
                        <h3 className="m-t0 m-b10 font-weight-700 title-head">
                          Teknik Özellikler
                        </h3>
                        <table className="table table-striped advert-spec-table">
                          <tbody>
                            {specRows.map(([label, value]) => (
                              <tr key={label}>
                                <th
                                  className="font-weight-700 text-black"
                                  style={{ width: "40%" }}
                                >
                                  {label}
                                </th>
                                <td>{value}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : null}

                    <h3 className="m-t0 m-b10 font-weight-700 title-head">
                      Açıklama
                    </h3>
                    {/*<ul className="job-info">
                      <li>
                        <strong>Yayınlanma : </strong>
                      </li>
                    </ul>*/}
                    <p className="p-t20 advert-body">
                      {props.advert.advertDetail.body}
                    </p>

                    {hasLocation ? (
                      <div className="advert-location-block mb-4">
                        <h3 className="m-t0 m-b10 font-weight-700 title-head">
                          Konum
                        </h3>
                        <p className="advert-location-text">
                          <i className="ti-location-pin mr-2" />
                          {advertDetail.location?.province?.name}
                          {advertDetail.location?.district?.name
                            ? ` / ${advertDetail.location.district.name}`
                            : ""}
                          {advertDetail.location?.neighborhood
                            ? ` / ${advertDetail.location.neighborhood}`
                            : ""}
                        </p>
                        {showLocationMap ? (
                          <>
                            <iframe
                              title="Konum Haritası"
                              src={mapEmbedUrl}
                              className="advert-location-map"
                              width="100%"
                              height="320"
                              style={{ border: 0, borderRadius: 8 }}
                              loading="lazy"
                              referrerPolicy="no-referrer-when-downgrade"
                            />
                            <p className="text-muted text-sm mt-2">
                              Harita yaklaşık bölgeyi gösterir; tam adres
                              içermez.
                            </p>
                          </>
                        ) : null}
                      </div>
                    ) : null}

                    <div id="contact-buyer-container" />
                    {isSeller ? null : props.advert.advertDetail.user.name ? (
                      <div
                        style={{
                          backgroundColor: "#ddfae3",
                          borderRadius: 10,
                          padding: 10,
                          marginBottom: 30,
                        }}
                      >
                        <h3>İlan Sahibi</h3>
                        <b>İsim</b> : {props.advert.advertDetail.user.name}{" "}
                        {props.advert.advertDetail.user.surname}
                        <br />
                        {props.advert.advertDetail.showPhoneNumber ? (
                          <>
                            <b>Telefon</b> :{" "}
                            {props.advert.advertDetail.privacy &&
                            props.advert.advertDetail.privacy[0]
                              ? props.advert.advertDetail.privacy[0].phone
                              : ""}
                            <br />
                          </>
                        ) : null}
                        <b>E-Posta </b>
                        {props.advert.advertDetail.user.email}
                        {props.advert.advertDetail.allowMessages ? (
                          <div className="mt-3">
                            <Link
                              to={`/messages/${props.advert.advertDetail.user.id}?advert=${props.advert.advertDetail.slug}`}
                              className="bg-primary p-2 rounded text-white send-message-button outline-none border-0 cursor-pointer"
                            >
                              Mesaj Gönder
                            </Link>
                          </div>
                        ) : null}
                      </div>
                    ) : (
                      <div>
                        <div className="dez-divider divider-2px bg-gray-dark mb-4 mt-0"></div>
                        <AdvertBuyDialog
                          open={dialog}
                          closeDialog={() => setDialog(false)}
                          advertDetail={advertDetail}
                          takeAdvert={() => {
                            takeAdvert(props.advert.advertDetail.id);

                            scrollToContactContainer();
                          }}
                        />

                        <div className="justify-content-between">
                          {isLogged && props.auth.user.role.includes("admin") && (
                            <Link
                              to={`/admin/adverts/${props.advert.advertDetail.id}`}
                            >
                              <button className="site-button mb-5">
                                İlanı Düzenle
                              </button>
                            </Link>
                          )}
                        </div>

                        <p className="text-muted text-sm mb-5">
                          İlan sahibinin iletişim bilgilerini görüntülemek için
                          {advertDetail.kind === "seller"
                            ? ' "Satıcı ile İletişime Geç"'
                            : ' "Alıcı ile İletişime Geç"'}{" "}
                          butonunu kullanabilirsiniz.
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {advertDetail.similarAdverts?.length > 0 ? (
                <div>
                  <h3>Benzer İlanlar</h3>

                  <div className="row">
                    {advertDetail.similarAdverts.map((advert, index) => {
                      return <AdvertCard advert={advert} key={index} />;
                    })}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </LayoutV1>
  );
}

export default connect(advertRedux.reducer, {
  ...advertRedux.actions,
  ...authRedux.actions,
  ...initialRedux.actions,
})(AdvertDetail);
